/**
 * Created by Kaku.Guo on 2018/11/23.
 */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {getMessage, Link} from '../../index';
import AssetDetailInfo from './AssetDetailInfo';
import AssetDetailRating from './AssetDetailRating';

const AssetDetailContent = props => {
    const {data = {}, messages, isLinkSeller, locale} = props;
    const {title, seller, effectiveDate, description, customAttributes} = data;
    const hasBuyLink = customAttributes && 'BuyLink' in customAttributes;
    return (
        <div className="asset-details__content">
            <div className="asset-detail-full">
                <div className="pull-left">
                    <h1 className="post-title">{title}</h1>
                </div>
                <div className="pull-right compatibility hidden">
                    <i
                        className="fa fa-2x fa-minus-circle no-engine"
                        title={getMessage(
                            messages,
                            'messages.com.epicgames.plugin.store.launcher.no_engine'
                        )}
                    />
                    <i
                        className="fa fa-2x fa-exclamation-circle incompatible"
                        title={getMessage(
                            messages,
                            'messages.com.epicgames.plugin.store.launcher.incompatible'
                        )}
                    />
                    <i
                        className="fa fa-2x fa-info-circle partial"
                        title={getMessage(
                            messages,
                            'messages.com.epicgames.plugin.store.launcher.partial'
                        )}
                    />
                    <i
                        className="fa fa-2x fa-check-circle compatible"
                        title={getMessage(
                            messages,
                            'messages.com.epicgames.plugin.store.launcher.compatible'
                        )}
                    />
                </div>
                <div className="clearfix" />
                {seller && (
                    <div className="asset-desc-nvs">
                        <span className="seller-name">
                            {isLinkSeller ? (
                                <Link to={`profile/${seller.name.replace(/ /g, '+')}`}>
                                    {seller.name}
                                </Link>
                            ) : (
                                seller.name
                            )}
                        </span>
                        {effectiveDate && (
                            <span className="">
                                &nbsp;-{' '}
                                {moment(effectiveDate)
                                    .locale(locale)
                                    .format('MMM D, YYYY')}
                            </span>
                        )}
                    </div>
                )}
                <AssetDetailRating external={hasBuyLink} />
                <p className="asset-detail-text">{description}</p>
            </div>
            <AssetDetailInfo {...props} />
        </div>
    );
};
AssetDetailContent.propTypes = {
    data: PropTypes.object,
    messages: PropTypes.object,
    isLinkSeller: PropTypes.bool,
    locale: PropTypes.string
};
export default AssetDetailContent;
